import { Reply } from "lucide-react";

interface MessagePreviewProps {
  message: {
    id: string;
    content: string;
    sender_id: string;
    media_type?: string;
    media_url?: string;
    sent_at: string;
    reply_to_id?: string;
    reply_to?: {
      id: string;
      content: string;
      sender_id: string;
      media_type?: string;
      media_url?: string;
      sent_at: string;
    };
  };
  senderName?: string;
  repliedToSenderName?: string;
  isCurrentUser: boolean;
  className?: string;
}

export default function MessagePreview({ 
  message, 
  senderName, 
  repliedToSenderName,
  isCurrentUser,
  className = "" 
}: MessagePreviewProps) {
  if (!message.reply_to || !message.reply_to_id) {
    return null;
  }

  return (
    <div className={`mb-2 ${className}`}>
      <div className="flex items-start gap-2 p-3 bg-muted/50 rounded-xl border border-primary/20 shadow-sm">
        <Reply className="w-4 h-4 text-primary/70 mt-1 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs font-semibold text-primary">
              Replying to {repliedToSenderName || 'Unknown User'}
            </span>
          </div>
          <div className="text-sm text-muted-foreground line-clamp-2 pl-3 border-l-2 border-primary/30 bg-background/50 rounded-r-lg py-1">
            {message.reply_to.media_type ? (
              <span className="italic flex items-center gap-1">
                <span className="text-base">
                  {message.reply_to.media_type === 'image' ? '📷' : 
                   message.reply_to.media_type === 'video' ? '🎬' : 
                   message.reply_to.media_type === 'gif' ? '🎭' : '📎'}
                </span>
                {message.reply_to.media_type === 'image' ? 'Image' : 
                 message.reply_to.media_type === 'video' ? 'Video' : 
                 message.reply_to.media_type === 'gif' ? 'GIF' : 'Media'}
                {message.reply_to.content && ` • ${message.reply_to.content}`}
              </span>
            ) : (
              <span className="font-medium">{message.reply_to.content || 'Message'}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}